import { fetchStrikethrough } from '@/features/strikethrough/fetchStrikethrough';

import { FetchablePartName, type TFetchableArgs, type TFetchablePart } from '../types';

const strikethrough: TFetchablePart<FetchablePartName.STRIKETHROUGH> = {
  fetcher: ({ fetchOptions, onResponseHeaders }: TFetchableArgs) => {
    return fetchStrikethrough({ fetchOptions, onResponseHeaders });
  },
  name: FetchablePartName.STRIKETHROUGH,
};

export default strikethrough;
